// extracted by mini-css-extract-plugin
module.exports = {"resetPasswordLink":"theme_resetPasswordLink__2n0Rl","errorMessage":"theme_errorMessage__1RyAj"};